var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"d-flex justify-center align-center",attrs:{"fluid":"","fill-height":""}},[_c('Sign',{attrs:{"c":this.content,"id":this.idClient,"a":this.auth,"d":this.date,"w":"360px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }